// src/business/utils/businessSwal.js
export const businessSwalBase = {
  target: "#business-swal-root",
};
